var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsVegno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H30V26C30 28.2091 28.2091 30 26 30H0V4Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 6.2C22.9046 6.2 23.8 7.09543 23.8 8.2V21.8C23.8 22.9046 22.9046 23.8 21.8 23.8H8.2C7.09543 23.8 6.2 22.9046 6.2 21.8V8.2C6.2 7.09543 7.09543 6.2 8.2 6.2H21.8ZM26 6C26 4.89543 25.1046 4 24 4H6C4.89543 4 4 4.89543 4 6V24C4 25.1046 4.89543 26 6 26H24C25.1046 26 26 25.1046 26 24V6ZM16.8381 10.4894C16.1455 8.87317 13.8543 8.87309 13.1616 10.4893L9.59431 18.8121C9.02866 20.1318 9.99563 21.6 11.4315 21.6C12.4609 21.6 13.6861 21.6 15 21.6C16.3137 21.6 17.5385 21.6 18.5675 21.6C20.0033 21.6 20.9703 20.132 20.4047 18.8122L16.8381 10.4894Z",
    fill: "#990100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsVegno);
export default __webpack_public_path__ + "static/media/isVeg=no.9da68e61dc2bcf3b074a39ce374344a0.svg";
export { ForwardRef as ReactComponent };